import { render, staticRenderFns } from "./EtabFinance.vue?vue&type=template&id=2f051a31"
import script from "./EtabFinance.vue?vue&type=script&lang=js"
export * from "./EtabFinance.vue?vue&type=script&lang=js"
import style0 from "./EtabFinance.vue?vue&type=style&index=0&id=2f051a31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports